import React, { useState } from 'react';
import { Container } from 'react-bootstrap';

import ManualIndexing from './ManualIndexing';
import DemoSitesIndexing from './DemoSitesIndexing';
import '../styles/common.css';

// Available tabs in the indexing control panel
const AVAILABLE_TABS = [
    {
        key: 'manual',
        label: 'Manual Indexing',
        component: ManualIndexing,
    },
    {
        key: 'demo',
        label: 'Demo Sites Indexing Scheduler',
        component: DemoSitesIndexing,
    },
];

/**
 * IndexingControlPanel Component
 * Provides a tabbed interface for different indexing operations
 *
 * @returns {JSX.Element} The rendered component
 */
const IndexingControlPanel = () => {
    // State for managing active tab - always default to "manual"
    const [activeTab, setActiveTab] = useState('manual');

    // Get the component to render
    const ActiveComponent = AVAILABLE_TABS.find(
        (tab) => tab.key === activeTab
    )?.component;

    return (
        <div className="min-vh-100 app-background">
            <Container className="py-4">
                {/* Tabbed Navigation */}
                <div className="d-flex tab-container mb-4">
                    {AVAILABLE_TABS.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            className={`flex-fill py-2 fw-semibold border-0 tab-button ${
                                activeTab === tab.key
                                    ? 'bg-white text-dark border border-2 tab-button-active'
                                    : 'bg-transparent text-secondary'
                            }`}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div className="mt-4">
                    {ActiveComponent && <ActiveComponent />}
                </div>
            </Container>
        </div>
    );
};

export default IndexingControlPanel;
